module.exports = __webpack_public_path__ + "assets/4c9fdb6156a544699dff71d97ce6d555.svg";